<template>
  <div v-show="requestId">
    <div class="card">
      <div class="card-header">
        <div class="row">
          <div class="col resultText" style="text-align: left;" @mouseenter="handleResultEnter" @mouseleave="handleResultLeave">
            <div v-if="!done" class="spinner-border me-2" role="status" style="width: 1rem; height: 1rem;"></div>
            <span v-else class="me-2"><i class="fa-solid fa-check text-success"></i></span>
            <span class="status-text monospaced">{{ lastLogLine }}</span>
            <div v-show="showPopover" class="log-popover" @mouseenter="handlePopoverEnter" @mouseleave="handlePopoverLeave">
              <span class="log-popover-title">request log</span><br>
              <div class="log-output monospaced">
                <div v-for="(line, index) in logLines" :key="index" class="log-line">
                  {{ line }}
                </div>
              </div>
            </div>
          </div>
          <div class="col resultText text-end">
            <span class="clickable me-2 monospaced" @click="copyResult">
              <i class="fa-solid" :class="copied ? 'fa-check' : 'fa-paste'"></i>
              {{ copied ? 'Copied!' : 'Copy' }}
            </span>
            <span class="clickable me-2 monospaced" @click="copyLink">
              <i class="fa-solid" :class="copiedLink ? 'fa-check' : 'fa-link'"></i>
              {{ copiedLink ? 'Copied!' : 'Link' }}
            </span>
          </div>
        </div>
      </div>
      <div class="terminal-container monospaced">
        <pre class="terminal-output">{{ result }}</pre>
      </div>
    </div>
    <br>
    <button type="button" class="btn btn-lg btn-primary form-control monospaced" @click="$emit('reset')">
      <i class="fa-solid fa-repeat"></i> Make another request
    </button>
  </div>
</template>

<script>
export default {
  name: 'ResultDisplay',
  props: {
    requestId: String,
    done: Boolean,
    lastLogLine: String,
    result: String,
    log: String
  },
  data() {
    return {
      copied: false,
      copiedLink: false,
      showPopover: false,
      isOverResult: false,
      isOverPopover: false
    }
  },
  computed: {
    logLines() {
      return this.log.split('\n').filter(line => line.trim());
    }
  },
  methods: {
    copyResult() {
      this.copied = true
      navigator.clipboard.writeText(this.result)
      setTimeout(() => this.copied = false, 2000)
    },
    copyLink() {
      this.copiedLink = true
      navigator.clipboard.writeText(window.location.href)
      setTimeout(() => this.copiedLink = false, 2000)
    },
    handleResultEnter() {
      this.isOverResult = true;
      this.showPopover = true;
    },
    handleResultLeave() {
      this.isOverResult = false;
      this.checkHidePopover();
    },
    handlePopoverEnter() {
      this.isOverPopover = true;
      this.showPopover = true;
    },
    handlePopoverLeave() {
      this.isOverPopover = false;
      this.checkHidePopover();
    },
    checkHidePopover() {
      setTimeout(() => {
        if (!this.isOverResult && !this.isOverPopover) {
          this.showPopover = false;
        }
      }, 100);
    }
  }
}
</script>

<style scoped>
.terminal-container {
  background: black;
  border-radius: 0 0 0.375rem 0.375rem;
  padding: 1rem;
  min-height: 300px;
  max-height: 600px;
  overflow-y: auto;
}

.terminal-output {
  font-family: 'Ubuntu Mono', monospace;
  font-size: 14px;
  line-height: 1.2;
  margin: 0;
  white-space: pre-wrap;
  word-wrap: break-word;
  text-align: left;
  color: #ffffff;
}

.log-text {
  color: #888888;
}

.result-text {
  color: #ffffff;
}

.resultText {
  white-space: nowrap;
  overflow-x: auto;
}

.me-2 {
  margin-right: 0.5rem;
}

.text-success {
  color: green;
}

.card {
  box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;
}

/* Scrollbar styling */
.terminal-container::-webkit-scrollbar {
  width: 8px;
}

.terminal-container::-webkit-scrollbar-track {
  background: #1a1a1a;
  border-radius: 0 0 0.375rem 0;
}

.terminal-container::-webkit-scrollbar-thumb {
  background: #333;
  border-radius: 4px;
}

.terminal-container::-webkit-scrollbar-thumb:hover {
  background: #444;
}

.log-popover {
  position: fixed;
  text-align: left;
  top: auto;
  left: auto;
  transform: translateY(10px);
  background: #1a1a1a;
  border: 1px solid #333;
  border-radius: 4px;
  padding: 0.5rem;
  margin-top: 0.5rem;
  width: 500px;
  max-height: 300px;
  overflow-y: auto;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
  z-index: 9999;
}

.log-output {
  margin: 0;
  color: #fff;
  white-space: pre-wrap;
  word-wrap: break-word;
}

.log-line {
  position: relative;
  padding-left: 15px;
  line-height: 1.4;
}

.log-line::before {
  content: "•";
  position: absolute;
  left: 0;
  color: #666;
}

/* Update scrollbar styling for popover */
.log-popover::-webkit-scrollbar {
  width: 8px;
}

.log-popover::-webkit-scrollbar-track {
  background: #1a1a1a;
}

.log-popover::-webkit-scrollbar-thumb {
  background: #333;
  border-radius: 4px;
}

.log-popover::-webkit-scrollbar-thumb:hover {
  background: #444;
}
.log-popover-title {
  font-weight: bold;
  color: #aaa;
  margin-bottom: 0.5rem;
}
</style> 
